module.exports = __webpack_public_path__ + "static/contact.9afe8017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/contact.jpg
// module id = 103
// module chunks = 168707334958949